import type { GoogleAdsAccountsResponse } from '@common/api/authService';

export type GoogleAdsAccountResponseScope = {
  workspaceId: string | null;
  connectionId: string | null;
};

const normalizeScopeValue = (value: string | null | undefined) =>
  String(value || '').trim();

/**
 * An onboarding discovery response is only safe to reuse for the exact
 * workspace/connection request that produced it. A modal can otherwise reopen
 * while a previous response is still in React state and save the wrong parent
 * connection's customer selection.
 */
export const canReuseGoogleAdsAccountResponse = (
  response: GoogleAdsAccountsResponse | null,
  initialScope: GoogleAdsAccountResponseScope | null | undefined,
  currentScope: GoogleAdsAccountResponseScope,
): boolean => {
  if (!response || !initialScope) return false;

  const initialWorkspaceId = normalizeScopeValue(initialScope.workspaceId);
  const initialConnectionId = normalizeScopeValue(initialScope.connectionId);
  const currentWorkspaceId = normalizeScopeValue(currentScope.workspaceId);
  const currentConnectionId = normalizeScopeValue(currentScope.connectionId);
  if (
    !initialWorkspaceId ||
    !initialConnectionId ||
    !currentWorkspaceId ||
    !currentConnectionId ||
    initialWorkspaceId !== currentWorkspaceId ||
    initialConnectionId !== currentConnectionId
  ) {
    return false;
  }

  const responseConnectionId = normalizeScopeValue(response.connectionId);
  return !responseConnectionId || responseConnectionId === currentConnectionId;
};
